/*
 * @Description: 发票管理
 * @Date: 2025-06-11 16:04:23
 */

import { route, pushInvoiceList } from './src/router';
import InvoiceEnterpriseDialog from '@V/invoice/src/components/invoice-enterprise-dialog';

const name = 'invoice';

export { name, route, InvoiceEnterpriseDialog, pushInvoiceList };
